var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import './Select.scss';
var ClientSelect = function (_a) {
    var onChange = _a.onChange, isAddPerson = _a.isAddPerson, defaultValue = _a.defaultValue;
    var BodyTextOne = useCallback(function (_a) {
        var title = _a.title, size = _a.size;
        return (_jsx("div", __assign({ style: size ? { fontSize: size } : {}, className: "BodyTextOne" }, { children: title })));
    }, []);
    var options = [
        { value: '', label: _jsx(BodyTextOne, { title: "\u0412\u0441\u0435" }) },
        { value: 'сотрудник', label: _jsx(BodyTextOne, { title: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A" }) },
        // { value: 'управляющий', label: <BodyTextOne title="Управляющий" /> },
        // // { value: 'официант', label: <BodyTextOne title="Официант" /> },
    ];
    var addOptions = [
        { value: 'сотрудник', label: _jsx(BodyTextOne, { title: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A" }) },
        // { value: 'управляющий', label: <BodyTextOne title="Управляющий" /> },
        // // { value: 'официант', label: <BodyTextOne title="Официант" /> },
    ];
    var _b = useState(isAddPerson ? addOptions[0] : options[0]), selectedOption = _b[0], setSelectedOption = _b[1];
    useEffect(function () {
        console.log('DEFAULT', defaultValue);
        var optionsList = isAddPerson ? addOptions : options;
        if (defaultValue) {
            var optionToSelect = optionsList.find(function (option) { return option.value === defaultValue; });
            console.log('OPTION', optionToSelect);
            if (optionToSelect) {
                setSelectedOption(optionToSelect);
            }
        }
    }, [defaultValue, isAddPerson]);
    var CustomInput = useCallback(function (props) {
        return (_jsx(components.Input, __assign({}, props, { inputClassName: "AutoCompleteInput" })));
    }, []);
    var handleChange = function (selectedOption) {
        setSelectedOption(selectedOption);
        onChange(selectedOption);
    };
    return (_jsx(Select, { components: { Input: CustomInput }, styles: {
            control: function (base, state) {
                return (__assign(__assign({}, base), { borderRadius: '8px', borderBottomRightRadius: state.menuIsOpen ? 0 : '8px', borderBottomLeftRadius: state.menuIsOpen ? 0 : '8px', backgroundColor: isAddPerson ? '#F7F8FC' : 'white', border: isAddPerson ? '0px solid #E3E3E3' : '1px solid #E3E3E3', boxShadow: state.isFocused ? '0 0 0 1px #E3E3E3' : 'none', '&:hover': {
                        border: '1px solid #E3E3E3',
                    } }));
            },
            dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { color: '#000000', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '12px' })); },
            indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: 'none' })); },
            option: function (base, state) {
                return (__assign(__assign({}, base), { backgroundColor: state.isSelected ? '#E3E3E3' : 'white', color: 'black', '&:hover': {
                        backgroundColor: '#E3E3E3',
                    } }));
            },
            menu: function (base) { return (__assign(__assign({}, base), { marginTop: '0px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px', border: '1px solid #E3E3E3', borderTopWidth: 0 })); },
            menuList: function (base) { return (__assign(__assign({}, base), { color: 'black', padding: '0px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' })); },
            singleValue: function (base) { return (__assign(__assign({}, base), { color: 'black' })); },
        }, className: "Select", options: isAddPerson ? addOptions : options, value: selectedOption, onChange: handleChange }));
};
export default ClientSelect;
